import React from 'react'

import { Accordion } from '@mc/design-system'

export const FaqQuestion = ({
  title,
  uuid,
  children,
}: {
  title: string
  uuid: string
  children: React.ReactNode
}) => (
  <Accordion.Item
    className='mc-mb-4'
    headingAriaLevel={4}
    uuid={uuid}
    label={<p className='mc-text--bold'>{title}</p>}
  >
    {children}
  </Accordion.Item>
)
